/* eslint-disable */
// src/forms/person/updatePersonForm.js

import React, { Component } from "react";
import personService from "../../services/personService";
import PropTypes from "prop-types";
import {
  TextField,
  Grid,
  Container,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Alert,
} from "@mui/material";
import data from "../../assets/departamentos-y-ciudades.json";
import CancelButton from "components/common/CancelButton";
import AcceptButton from "components/common/AcceptButton";
import {
  getPersonApiErrorMessage,
  normalizePersonOptionalFieldsForPayload,
} from "utils/personOptionalFields";

class UpdatePersonForm extends Component {
  constructor(props) {
    super(props);
    const { person } = props;
    this.state = {
      person: person,
      selectedDepartamento: person ? person.Department : '',
      selectedCiudad: person ? person.City : '',
      errorMessage: "",
      showNameError: false,
    };
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      person: {
        ...prevState.person,
        [name]: value,
      },
      errorMessage: "",
      showNameError: name === "Name" ? false : prevState.showNameError,
    }));
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.state.person.Name?.trim()) {
      this.setState({ showNameError: true, errorMessage: "" });
      return;
    }
    try {
      const payload = normalizePersonOptionalFieldsForPayload(this.state.person);
      await personService.updatePerson(this.state.person.Id, payload);
      
      await this.props.onUpdateSuccess?.(this.state.person.Id);

      this.props.closeForm();
    } catch (error) {
      console.error("Hubo un error al actualizar el cliente:", error);
      this.setState({
        errorMessage: getPersonApiErrorMessage(error, "No se pudo actualizar la persona."),
      });
    }
  };

  handleDepartamentoChange = (event) => {
    const selectedDepartamento = event.target.value;
    this.setState(prevState => ({
      selectedDepartamento,
      selectedCiudad: '',
      person: {
        ...prevState.person,
        Department: selectedDepartamento,
        City: '',
      },
      errorMessage: "",
    }));
  };

  handleCiudadChange = (event) => {
    const selectedCiudad = event.target.value;
    this.setState(prevState => ({
      selectedCiudad,
      person: {
        ...prevState.person,
        City: selectedCiudad
      }
    }));
  };

  render() {
    return (
      <Container component={Paper} style={{ padding: "20px", marginTop: "20px" }}>
        <form onSubmit={this.handleSubmit} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nombre"
                required
                name="Name"
                value={this.state.person.Name}
                onChange={this.handleChange}
                error={this.state.showNameError}
                helperText={this.state.showNameError ? "Ingresá un nombre." : ""}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Celular"
                name="Contact"
                value={this.state.person.Contact ?? ""}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Cuenta"
                name="Account"
                value={this.state.person.Account ?? ""}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Departamento</InputLabel>
                <Select
                  value={this.state.selectedDepartamento}
                  onChange={this.handleDepartamentoChange}
                  label="Departamento"
                >
                  {data.map((departamento) => (
                    <MenuItem key={departamento.id} value={departamento.name}>
                      {departamento.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={8}>
                  <TextField
                    fullWidth
                    label="Dirección"
                    name="Address"
                    value={this.state.person.Address ?? ""}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth disabled={!this.state.selectedDepartamento}>
                    <InputLabel>Ciudad</InputLabel>
                    <Select
                      value={this.state.selectedCiudad}
                      onChange={this.handleCiudadChange}
                      label="Ciudad"
                    >
                      {data
                        .find((departamento) => departamento.name === this.state.selectedDepartamento)
                        ?.towns.map((ciudad) => (
                          <MenuItem key={ciudad.id} value={ciudad.name}>
                            {ciudad.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sx={{ mt: 1 }}>
              {this.state.errorMessage && (
                <Alert severity="error" sx={{ mb: 2 }}>{this.state.errorMessage}</Alert>
              )}
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <CancelButton onClick={this.props.closeForm} fullWidth>
                    Cancelar
                  </CancelButton>
                </Grid>

                <Grid item xs={12} md={6}>
                  <AcceptButton type="submit" fullWidth>
                    Guardar cambios
                  </AcceptButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Container>
    );
  }
}

UpdatePersonForm.propTypes = {
  closeForm: PropTypes.func.isRequired,
  person: PropTypes.object.isRequired,
  onUpdateSuccess: PropTypes.func,
};
export default UpdatePersonForm;
